import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import styles from './AdminLogin.module.css';

const AdminLogin = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleAdminLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await login(formData.email, formData.password);
      if (res && res.profile && res.profile.role === 'admin') {
        navigate('/admin/dashboard');
      } else {
        setError('Acceso solo para administradores.');
      }
    } catch (err) {
      setError('Credenciales incorrectas o usuario no autorizado.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.adminLoginContainer}>
      <form className={styles.adminLoginForm} onSubmit={handleAdminLogin}>
        <h2 className={styles.title}>Acceso Administrador</h2>
        <p className={styles.subtitle}>Solo para personal autorizado</p>
        <div className={styles.field}>
          <label className={styles.label} htmlFor="admin-email">
            Correo de administrador
          </label>
          <input
            id="admin-email"
            type="email"
            name="email"
            placeholder="admin@tusitio.com"
            value={formData.email}
            onChange={handleInputChange}
            className={styles.input}
            autoComplete="username"
          />
        </div>
        <div className={styles.field}>
          <label className={styles.label} htmlFor="admin-password">
            Contraseña
          </label>
          <input
            id="admin-password"
            type="password"
            name="password"
            placeholder="Contraseña"
            value={formData.password}
            onChange={handleInputChange}
            className={styles.input}
            autoComplete="current-password"
          />
        </div>
        {error && <div className={styles.error}>{error}</div>}
        <button type="submit" className={styles.button} disabled={loading}>
          {loading ? 'Ingresando...' : 'Entrar'}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
